<template>
    <div class="page-table haberTanim mainDiv" id="affix-container">
        <div class="animated fadeInUp card-base baslikBg">{{$t("src.views.apps.partner.tanimlama.baslikH1")}}</div>
        <el-row :gutter="10">
            <el-form status-icon :model="partnerForm" :rules="rulesPartnerlar" ref="partnerForm" class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.partner.tanimlama.partnerAdi")'
                                              prop="partnerAdi">:
                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                              v-model="partnerForm.partnerAdi"
                                              :placeholder='$t("src.views.apps.partner.tanimlama.partnerAdiPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.partner.tanimlama.adres")'
                                              prop="adres">:
                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                              v-model="partnerForm.adres" type="textarea"
                                              :placeholder='$t("src.views.apps.partner.tanimlama.adresPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.partner.tanimlama.harita")'
                                              prop="harita">:
                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                              type="textarea"
                                              v-model="partnerForm.harita"
                                              :placeholder='$t("src.views.apps.partner.tanimlama.haritaPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="6" :md="6" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='Resim'
                                              prop="image">:
                                    <el-upload
                                            action=""
                                            :auto-upload="false"
                                            :limit="1"
                                            :on-change="imageUpload"
                                            :on-remove="imageRemove"
                                            accept=".jpg,.jpeg,.png"
                                            ref="upload"
                                            list-type="picture-card">
                                        <i slot="default" class="el-icon-plus"></i>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp" v-model="activeCollapse">
                        <el-collapse-item class="card-shadow--medium" name="1" :title='$t("src.views.apps.partner.tanimlama.durum")'>
                            <el-row>
                                <el-button
                                        size="mini" v-on:click="partnerTanimlama('partnerForm')"
                                        class="onayBtn"
                                        type="primary">
                                    <label>{{$t('src.views.apps.partner.tanimlama.partnerEkle')}}</label>
                                </el-button>
                                &nbsp;
                                <el-popover
                                        placement="bottom"
                                        width="300"
                                        v-model="visibleSil">
                                    <p>{{$t('src.views.apps.yonetici.tanimlama.formAlertP')}}</p>
                                    <div style="text-align: right; margin: 0">
                                        <el-button size="mini" type="primary" @click="resetForm('partnerForm')">
                                            {{$t('src.views.apps.yonetici.tanimlama.evet')}}
                                        </el-button>
                                        <el-button size="mini" @click="visibleSil = false;">
                                            {{$t('src.views.apps.yonetici.tanimlama.hayir')}}
                                        </el-button>
                                    </div>
                                    <el-button size="mini" slot="reference">
                                        {{$t('src.views.apps.yonetici.tanimlama.temizle')}}
                                    </el-button>
                                </el-popover>
                                <el-tooltip :content="$t('src.views.apps.partner.tanimlama.copKutusu')"
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button class="cop" v-on:click="partnerTanimlama('partnerForm','2')" type="text"
                                               icon="el-icon-delete"></el-button>
                                </el-tooltip>
                            </el-row>
                        </el-collapse-item>
                        <draggable class="list-group" group="a">
                            <el-collapse-item class="card-shadow--medium" :title='$t("src.views.apps.partner.tanimlama.telefon")' name="2">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="telefon">
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                      v-model="partnerForm.telefon" v-mask="'+90(###)### ## ##'"
                                                      placeholder="+90(555)555 55 55"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium" :title='$t("src.views.apps.partner.tanimlama.mail")' name="4">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="mail">
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)" type="email"
                                                      v-model="partnerForm.mail"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium" :title='$t("src.views.apps.partner.tanimlama.webSite")' name="3">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="webSite">
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                      class="input-with-select"
                                                      v-model="partnerForm.webSite">
                                                <el-select v-on:change="$store.commit('changeTabsClose', false)"
                                                           v-model="select" slot="prepend" placeholder="Select">
                                                    <el-option label="http://" value="1"></el-option>
                                                    <el-option label="https://" value="2"></el-option>
                                                </el-select>
                                            </el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                        </draggable>
                    </el-collapse>
                </el-col>
            </el-form>
        </el-row>
    </div>
</template>

<script>
    import JQuery from 'jquery';
    import ClassicEditor from '../../../../node_modules/ckeditor5-build-classic';

    let $ = JQuery;
    import draggable from "vuedraggable";

    import partnerService from '../../../WSProvider/PartnerService'
    import controllerService from '../../../WSProvider/ControllerService'
    import notification from '../../../notification'

    let base64 = require('base64_js');
    let userDataEstas = "";

    export default {
        name: "PartnerTanimlama",
        components: {
            draggable
        },
        data() {
            return {
                select: '1',
                drawerResimKonum: false,
                drawerMenuKonum: false,
                drawerGaleriKonum: false,
                activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                imageListServer: [],
                fileListServer: [],
                dialogImgServerVisible: false,
                dialogDocServerVisible: false,
                editor: ClassicEditor,
                editorConfig: {
                    language: 'tr',
                },
                linkVisible: false,

                //Tree
                visibleUstPartner: false,
                treeList: [],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                // Form
                btnResim: "Seç",
                btnMenu: "Seç",
                btnGaleri: "Seç",
                linkChange: true,
                seoicerikChange: true,
                seoicerikIngChange: true,
                VisibleA: false,
                duzenleBtnVisible: true,
                visibleSil: false,
                imageListMain: [],
                fileListMain: [],
                partnerForm: {
                    partnerAdi: "",
                    adres: "",
                    image: "",
                    imageBase: "",
                    harita: "",
                    resim: [],
                    telefon: '',
                    mail: '',
                    webSite: '',
                    durum: "1",
                },
                rulesPartnerlar: {
                    partnerAdi: [{
                        required: true,
                        message: "Lütfen Partner Adı Giriniz",
                        trigger: 'blur'
                    }],
                    mail: [
                        {
                            type: 'email',
                            required: false,
                            message: 'Lütfen Geçerli Bir E-Posta Giriniz',
                            trigger: 'blur'
                        },
                    ],
                },
            }
        },
        mounted() {
        },
        methods: {
            imageUpload(file) {
                $('.el-upload--picture-card').hide();
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.partnerForm.partnerAdi) {
                        var imgName = randomText(7) + '-' + linkTemizle(this.partnerForm.partnerAdi) + ".png";
                    } else {
                        imgName = randomText(7) + '-' + linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".png";
                    }
                    this.partnerForm.image = imgName;
                    this.sumResimFonk(file,imgName)
                } else {
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            sumResimFonk(file, imgname) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        controllerService.resimYukle('partner', imgname, data).then((response) => {
                            if (response.status === 200) {
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            imageRemove() {
                $('.el-upload--picture-card').show();
            },
            partnerTanimlama(formName) {
                let self = this;
                this.partnerForm.resim = [];
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.imageListMain.forEach(function (e) {
                            self.partnerForm.resim.push(e.name);
                        });
                        var webSite = '';
                        if (this.partnerForm.webSite) {
                            switch (this.select) {
                                case '1' :
                                    webSite = "http://" + this.partnerForm.webSite;
                                    break;
                                case '2' :
                                    webSite = "https://" + this.partnerForm.webSite;
                                    break;
                            }
                        }
                        partnerService.partnerTanimlama(this.partnerForm.partnerAdi, this.partnerForm.image, this.partnerForm.telefon, this.partnerForm.adres, this.partnerForm.mail, this.partnerForm.harita, webSite).then((response) => {
                            if (response.status === 200) {
                                notification.Status('success', this, 'Partner başarıyla eklendi.');
                                this.resetForm(formName);
                                this.partnerForm.ustPartnerKodu = '';
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir partner zaten mevcut');

                            } else {
                                notification.Status(notification.status, this);
                            }
                        })
                    }
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                $('.el-upload-list__item-delete').click();
                this.visibleSil = false;
                this.partnerForm.partnerTuru = '0';
                this.visibleUstPartner = false;
                this.partnerForm.link = null;
                this.linkVisible = false;
            },
        }

    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")
            .toLowerCase();

    }

    function randomText(length) {
        let today = new Date();
        let day = today.getDate();
        let mounth = (today.getMonth() + 1);
        let year = today.getFullYear();
        let bugun = year + '' + (mounth <= 9 ? '0' + mounth : mounth) + '' + (day <= 9 ? '0' + day : day);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return bugun + "-" + text;
    }


</script>

<style scoped>

    .cop {
        color: #ec205f;
        position: relative;
        float: right;
        right: 15px;
        bottom: 10px;
        font-size: 20px;
    }

    .yanForm .card {
        margin-top: 10px;
    }
</style>